<template>
  <div>
    <el-dialog
      title="订单详情"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="800px"
      v-dialogDrag
      @close="close"
    >
      <div class="flexBox">
        <div class="spanBox" v-for="(item, index) in txtObj" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="txt">{{ dataObj[item.key] }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 订单详情弹窗
 * 功能：按 platform 区分调用 Amazon/eBay 订单详情接口，展示物流方式、跟踪号、金额等字段。
 */
import { getAmazonOrderInfo, getFeeBackOrderDetail } from "@/api/user";
export default {
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 平台id 1：Amazon；2：ebay
    platform: {
      type: Number,
      default: () => {
        return 1;
      },
    },
  },
  data() {
    return {
      // 按钮禁用状态（未使用）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 订单详情数据
      dataObj: {},
      // 详情展示字段配置（标题与数据 key 对应关系）
      txtObj: [
        { title: "物流方式", key: "logisticsName" },
        { title: "跟踪号", key: "expressNumber" },
        { title: "下单时间", key: "orderDownTime" },
        { title: "付款时间", key: "payTime" },
        { title: "退款金额", key: "refundAmount" },
        { title: "订单总金额", key: "orderAmount" },
        { title: "货币", key: "orderCurrency" },
      ],
    };
  },
  /** 弹窗打开时加载订单详情 */
  created() {
    this.init();
  },
  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /** 按平台加载对应订单详情接口的数据 */
    init() {
      if (this.platform === 1) {
        // 亚马逊中差评列表、亚马逊退款记录列表订单详情
        getAmazonOrderInfo({ orderId: this.scope.orderId }).then((res) => {
          if (res.code === 200) {
            this.dataObj = res.data;
          }
        });
      } else {
        // ebay中差评列表订单详情
        getFeeBackOrderDetail({ orderId: this.scope.orderId }).then((res) => {
          if (res.code === 200) {
            this.dataObj = res.data;
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.spanBox {
  height: 32px;
  display: flex;
  div {
    // display: inline-block;
    border: 1px solid #ebeef5;
    font-size: 14px;
    line-height: 32px;
    height: 32px;
  }

  .title {
    width: 28%;
    text-align: center;
    font-weight: bold;
    border-bottom: none;
  }

  .txt {
    width: 70%;
    border-bottom: none;
    border-left: none;
    padding-left: 10px;
  }
}
.spanBox:last-child {
  div {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
</style>